/**
 * Converts propTypes of hex color codes into variations
 * of the hexcolor, including uppercase, lowercase, and
 * longhand
 * @param {array} propTypes - array of hexcolor codes (eg #efefef, #fff)
 * @return {array} allPropCases - array of variations of inputterd hexcolor codes
 */
var getAllPropCasesForColors = function getAllPropCasesForColors(propTypes) {
  var allPropCases = [];
  propTypes.forEach(function (hexcode) {
    var upperCases = [hexcode.toUpperCase()];
    var lowerCases = [hexcode.toLowerCase()]; // If is hexcolor code shorthand, also add longhands

    if (hexcode.length === 4) {
      var extendedShortcut = hexcode[0].concat(hexcode[1].repeat(2), hexcode[2].repeat(2), hexcode[3].repeat(2));
      upperCases.push(extendedShortcut.toUpperCase());
      lowerCases.push(extendedShortcut.toLowerCase());
    }

    allPropCases.push.apply(allPropCases, upperCases.concat(lowerCases));
  });
  return allPropCases;
};

export default getAllPropCasesForColors;